export const submitUserFeedback = () => `/api/Feedback/UserFeedback`;
export const submitBugReport = () => `/api/Feedback/BugReport`;
